import { Box, CircularProgress, Snackbar } from "@mui/material";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "stores";
import { getAppState } from "stores/modules/app.state/selectors";

const LoadingRoomImport = () => {
  const isImportLoading = useAppSelector((state) =>
    getAppState(state, "isImportLoading")
  );
  const [t] = useTranslation();

  return (
    <Snackbar
      open={isImportLoading}
      message={
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
          }}
        >
          <CircularProgress size={15} />
          {t("ルームデータをインポート中")}
        </Box>
      }
    />
  );
};

export default memo(LoadingRoomImport);
